<template>
  <div class="window-f-box">
    <ul class="metro master-metro">
      <li @click="go(item)" v-for="item in list" :key="item.name">
        <i class="iconfont" :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
  // import { ref } from 'vue';
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const list = [
    {
      name: 'Calendar',
      icon: 'icon-calendar',
      url: '/calendar',
    },
    {
      name: 'Schedule Ctrl',
      icon: 'icon-clock-o',
      url: '/master?type=13',
    },
    {
      name: 'WS BOM',
      icon: 'icon-wuliaomingxi',
      url: '/bom',
    },
    {
      name: 'WS Tool',
      icon: 'icon-tool-o',
      url: '/master?type=20',
    },
    {
      name: 'WS Skill',
      icon: 'icon-skills',
      url: '/master?type=19',
    },
    {
      name: 'Supply Network',
      icon: 'icon-wangluo',
      url: '',
    },
    {
      name: 'Staging Waterlevel',
      icon: 'icon-shuiwei',
      url: '/master?type=14',
    },
    {
      name: 'ConWIP Parameters',
      icon: 'icon-canshu1',
      url: '',
    },
  ]
  const go = (item) => {
    router.push(item.url)
  }
</script>
<style lang="less" scoped>
  @import './less/_window-f-box.less';
</style>
